// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"5c63e80a","176":"0f0b143a","641":"9a2fd901","865":"7c811b96","989":"e5b0f3a1"}[chunkId] + ".chunk.js";
};